import React, { useState, ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import LoginView from "./LoginView";
import SignUpView from "./SignUpView";
import ConfirmationView from "./ConfirmationView";
import { ISignUp } from "./types";
import {
  handleSignUp,
  handleSignIn,
  handleSignUpConfirmation,
} from "./helpers";

const LoginContainer: React.FC = (): ReactElement => {
  const [state, setState] = useState<ISignUp>({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const string =
    "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJlcVJKMDhGMTFBQi14QWhnNnNSbXdxSE5PdzllS09JbmJaSVpISmpoOVc4In0.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.ORW66gg9EbWpbxapX6YGAOXmaAxfG-XmcJ6XoL8MhR4pVVoNSM2ogiyz6rnLZ30shgI7IkjsY3DtnbRL69_DXq4vq_eZ9EtlatyADyhLfRc2tZdwjggLpakmvJ61sSLLmmEfM5qq6PkNe0xoTgJI-7Oa3_MXAGAL5-bQms2ZPfBNNEDaJ_3YUxNcYTL_8zlEACJCRcm8zkad7dtepX96neHajLkCkUBe50Kn7Btm12FI-tAcEGE-6n-3WcjmF1v05nl-xtn1B_MYZXErvYxsMK1KnA-hbgbbOrtyNT_UsmllnRIToVBTfSuZiYVzTeqkdt87LMutSmoyiUQQ2VkXkg";

  console.log("string length", string.length);
  const [loginStage, setLoginStage] = useState<string>("login");

  const [segments, setSegments] = useState<string[]>(["", "", "", "", "", ""]);

  const navigate = useNavigate();

  const onPaste = (event: any): void => {
    const pasted = event.clipboardData.getData("text/plain");
    setSegments(pasted.split("").slice(0, segments.length));
  };

  const handleSegmentChange = (value: string, index: number) => {
    const newSegments = segments.with(index, value);
    setSegments(newSegments);
  };

  const handleChange: Function = (value: string, key: string): void => {
    setState({ ...state, [key]: value });
  };

  const handleConfirmationSubmit = () => {
    const confirmationCode = segments.join("");
    handleSignUpConfirmation(
      { username: state.email, confirmationCode },
      navigate,
    );
  };

  const handleSignUpSubmit = () => {
    const output = handleSignUp({
      username: state.email,
      email: state.email,
      password: state.password,
    });
    setLoginStage("confirm");
  };

  const handleSignInSubmit = async () => {
    const nextStep = handleSignIn({
      username: state.email,
      password: state.password,
    });
    if (nextStep && typeof nextStep === "object") {
      navigate("/home");
    }
    console.log(nextStep);
  };

  return (
    <>
      {loginStage === "login" && (
        <LoginView
          email={state.email}
          password={state.password}
          handleChange={handleChange}
          handleSubmit={handleSignInSubmit}
          handleLoginState={setLoginStage}
        />
      )}

      {loginStage === "signup" && (
        <SignUpView
          email={state.email}
          password={state.password}
          confirmPassword={state.confirmPassword}
          handleChange={handleChange}
          handleSubmit={handleSignUpSubmit}
          isLoading={false}
        />
      )}

      {loginStage === "confirm" && (
        <ConfirmationView
          segments={segments}
          onPaste={onPaste}
          handleChange={handleSegmentChange}
          handleConfirmation={handleConfirmationSubmit}
          username={state.email}
        />
      )}
    </>
  );
};

export default LoginContainer;
